import { render, staticRenderFns } from "./RequestPreview.vue?vue&type=template&id=3d4a7a22"
import script from "./RequestPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports